import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const putArchiveObjectDoc = async (info: { slug: string; docID: number }) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/object-docs/${info.slug}/archive_document/`,
    {
      id: info.docID,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.data as any;
};
